import React from 'react';
import { Tabs } from 'antd';
import { buildTitleBarTab } from './systemSettings/titleBarTab';
import { buildNavBarTab } from './systemSettings/navBarTab';
import { buildCommandPasswordTab } from './systemSettings/commandPasswordTab';
import { buildMapSettingsTab } from './systemSettings/mapSettingsTab';
import { buildMapProviderTab } from './systemSettings/mapProviderTab';
import { buildAppMapSettingsTab } from './systemSettings/appMapSettingsTab';
import { buildIconLibraryTab } from './systemSettings/iconLibraryTab';
import { buildFrontlineTab } from './systemSettings/frontlineTab';
import { buildRescuePushSettingsTab } from './systemSettings/rescuePushSettingsTab';
import { buildTrackManagementTab } from './systemSettings/trackManagementTab';
import { buildHomepageTab } from './systemSettings/homepageTab';
import { buildDbSchemaTab } from './systemSettings/dbSchemaTab';
import { buildAuditLogTab } from './systemSettings/auditLogTab';

/** 构建系统设置标签页，保留既有二级菜单顺序和保存操作。 */
export function buildSystemSettingsTab(context) {
  const { shouldShowPage } = context;
  const tabs = [];

  // 有「系统设置」总权限，或任一子项权限时，显示系统设置大类
  const canOpenSystemSettings = shouldShowPage('系统设置')
    || shouldShowPage('标题栏设置')
    || shouldShowPage('导航栏设置')
    || shouldShowPage('首页设置')
    || shouldShowPage('指挥系统密码')
    || shouldShowPage('指挥系统设置')
    || shouldShowPage('前线队员设置')
    || shouldShowPage('轨迹数据管理')
    || shouldShowPage('救援推送')
    || shouldShowPage('地图设置')
    || shouldShowPage('底图源设置')
    || shouldShowPage('单兵 App 设置')
    || shouldShowPage('图标库管理')
    || shouldShowPage('数据库结构');

  if (canOpenSystemSettings) {
    const commandSystemTabs = [];

    const titleTab = buildTitleBarTab(context);
    const navTab = buildNavBarTab(context);

    const commandPwdTab = buildCommandPasswordTab(context);
    if (commandPwdTab) commandSystemTabs.push(commandPwdTab);

    const frontlineTab = buildFrontlineTab(context);
    if (frontlineTab) commandSystemTabs.push(frontlineTab);

    const rescuePushTab = buildRescuePushSettingsTab(context);
    if (rescuePushTab) commandSystemTabs.push(rescuePushTab);

    const trackTab = buildTrackManagementTab(context);
    if (trackTab) commandSystemTabs.push(trackTab);

    const homepageTabItem = buildHomepageTab(context);
    const dbTab = buildDbSchemaTab(context);
    const auditTab = buildAuditLogTab(context);

    const mapSettingsTab = buildMapSettingsTab(context);
    const mapProviderTab = buildMapProviderTab(context);
    const appMapTab = buildAppMapSettingsTab(context);
    const iconLibraryTab = buildIconLibraryTab(context);
    let mapConfigTab = null;
    if (mapSettingsTab || mapProviderTab || appMapTab || iconLibraryTab) {
      const mapNestedTabs = [];
      if (mapSettingsTab) mapNestedTabs.push(mapSettingsTab);
      if (mapProviderTab) mapNestedTabs.push(mapProviderTab);
      if (appMapTab) mapNestedTabs.push(appMapTab);
      if (iconLibraryTab) mapNestedTabs.push(iconLibraryTab);
      mapConfigTab = {
        key: 'map_config',
        label: '地图配置',
        children: (
          <Tabs
            defaultActiveKey={mapNestedTabs[0].key}
            items={mapNestedTabs}
          />
        )
      };
    }

    const orderedSystemTabs = [];
    if (homepageTabItem) orderedSystemTabs.push(homepageTabItem);
    if (titleTab) orderedSystemTabs.push(titleTab);
    if (navTab) orderedSystemTabs.push(navTab);
    if (commandSystemTabs.length > 0) {
      orderedSystemTabs.push({
        key: 'command_system_settings',
        label: '指挥系统设置',
        children: (
          <Tabs
            defaultActiveKey={commandSystemTabs[0].key}
            items={commandSystemTabs}
          />
        )
      });
    }
    if (mapConfigTab) orderedSystemTabs.push(mapConfigTab);
    if (dbTab) orderedSystemTabs.push(dbTab);
    if (auditTab) orderedSystemTabs.push(auditTab);

    if (orderedSystemTabs.length > 0) {
      tabs.push({
        key: 'system_settings',
        label: '系统设置',
        children: (
          <Tabs
            defaultActiveKey={orderedSystemTabs[0].key}
            items={orderedSystemTabs}
          />
        )
      });
    }
  }

  return tabs[0] || null;
}
